export function regulamentoDisabled(state) {
  return !state.regulamento.attributes.analistaId
  || !state.regulamento.attributes.operadorId
  || !state.regulamento.attributes.dataInicio;
}
